/**
 * Additional Phrases - Round 1
 * 额外短语 - 第一轮
 * Target: +259 phrases to reach 1000 total
 */

import { Phrase } from './phrases';

export const additionalPhrasesRound1: Phrase[] = [
  // ==================== 小学3-4年级基础短语补充（80个）====================

  // 问候与礼貌用语扩展（20个）
  {
    id: 'add-greeting-1',
    phrase: 'How do you do?',
    meaning: '你好（正式）',
    example: 'How do you do? Nice to meet you.',
    exampleTranslation: '你好，很高兴见到你。',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-greeting-2',
    phrase: 'See you later',
    meaning: '回头见',
    example: 'See you later, alligator!',
    exampleTranslation: '回头见，鳄鱼！',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-greeting-3',
    phrase: 'Have a good day',
    meaning: '祝你今天愉快',
    example: 'Have a good day at school!',
    exampleTranslation: '祝你上学愉快！',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-greeting-4',
    phrase: 'Have a nice weekend',
    meaning: '周末愉快',
    example: 'Have a nice weekend!',
    exampleTranslation: '周末愉快！',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-greeting-5',
    phrase: 'Take care',
    meaning: '保重',
    example: 'Take care of yourself.',
    exampleTranslation: '照顾好自己。',
    category: 'greetings',
    difficulty: 'easy',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-greeting-6',
    phrase: 'Bless you',
    meaning: ' bless you（打喷嚏后）',
    example: 'Bless you! Are you okay?',
    exampleTranslation: ' bless you！你还好吗？',
    category: 'greetings',
    difficulty: 'easy',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-greeting-7',
    phrase: 'Congratulations',
    meaning: '恭喜',
    example: 'Congratulations on your birthday!',
    exampleTranslation: '祝你生日快乐！',
    category: 'greetings',
    difficulty: 'medium',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-greeting-8',
    phrase: 'Good luck',
    meaning: '祝你好运',
    example: 'Good luck on your test!',
    exampleTranslation: '祝你考试好运！',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-greeting-9',
    phrase: 'Well done',
    meaning: '做得好',
    example: 'Well done! You got an A!',
    exampleTranslation: '做得好！你得了A！',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-greeting-10',
    phrase: 'Excuse me',
    meaning: '打扰一下',
    example: 'Excuse me, where is the bathroom?',
    exampleTranslation: '打扰一下，洗手间在哪里？',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-greeting-11',
    phrase: 'After you',
    meaning: '你先请',
    example: 'After you, please.',
    exampleTranslation: '请先走。',
    category: 'greetings',
    difficulty: 'medium',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-greeting-12',
    phrase: 'Pardon me',
    meaning: '原谅我',
    example: 'Pardon me, I didn\'t hear you.',
    exampleTranslation: '抱歉，我没听清。',
    category: 'greetings',
    difficulty: 'medium',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-greeting-13',
    phrase: 'Never mind',
    meaning: '没关系',
    example: 'Never mind, it\'s okay.',
    exampleTranslation: '没关系，没事的。',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-greeting-14',
    phrase: 'That\'s all right',
    meaning: '没关系',
    example: 'That\'s all right. Don\'t worry.',
    exampleTranslation: '没关系，别担心。',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-greeting-15',
    phrase: 'It doesn\'t matter',
    meaning: '没关系',
    example: 'It doesn\'t matter to me.',
    exampleTranslation: '对我来说没关系。',
    category: 'greetings',
    difficulty: 'medium',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-greeting-16',
    phrase: 'No problem',
    meaning: '没问题',
    example: 'No problem, I can help.',
    exampleTranslation: '没问题，我可以帮忙。',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-greeting-17',
    phrase: 'With pleasure',
    meaning: '很乐意',
    example: 'With pleasure, let me help you.',
    exampleTranslation: '很乐意，让我帮你。',
    category: 'greetings',
    difficulty: 'medium',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-greeting-18',
    phrase: 'My pleasure',
    meaning: '我的荣幸',
    example: 'My pleasure to help you.',
    exampleTranslation: '很荣幸能帮助你。',
    category: 'greetings',
    difficulty: 'medium',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-greeting-19',
    phrase: 'Don\'t mention it',
    meaning: '别客气',
    example: 'Don\'t mention it, it was nothing.',
    exampleTranslation: '别客气，这没什么。',
    category: 'greetings',
    difficulty: 'medium',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-greeting-20',
    phrase: 'At your service',
    meaning: '为您效劳',
    example: 'I\'m at your service.',
    exampleTranslation: '随时为您效劳。',
    category: 'greetings',
    difficulty: 'medium',
    grade: '5',
    frequency: 'low'
  },

  // 日常活动短语（20个）
  {
    id: 'add-daily-1',
    phrase: 'wake up',
    meaning: '醒来',
    example: 'I wake up at 7 o\'clock.',
    exampleTranslation: '我7点醒来。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-daily-2',
    phrase: 'get dressed',
    meaning: '穿衣服',
    example: 'I get dressed for school.',
    exampleTranslation: '我穿好衣服准备上学。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-daily-3',
    phrase: 'have breakfast',
    meaning: '吃早餐',
    example: 'I have breakfast at 7:30.',
    exampleTranslation: '我7点半吃早餐。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-daily-4',
    phrase: 'brush teeth',
    meaning: '刷牙',
    example: 'I brush my teeth twice a day.',
    exampleTranslation: '我每天刷两次牙。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-daily-5',
    phrase: 'comb hair',
    meaning: '梳头发',
    example: 'I comb my hair every morning.',
    exampleTranslation: '我每天早上梳头发。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    frequency: 'medium'
  },
  {
    id: 'add-daily-6',
    phrase: 'go to school',
    meaning: '去上学',
    example: 'I go to school by bus.',
    exampleTranslation: '我坐公交车去上学。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-daily-7',
    phrase: 'come home',
    meaning: '回家',
    example: 'I come home at 4 pm.',
    exampleTranslation: '我下午4点回家。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-daily-8',
    phrase: 'have lunch',
    meaning: '吃午餐',
    example: 'I have lunch at school.',
    exampleTranslation: '我在学校吃午餐。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-daily-9',
    phrase: 'have dinner',
    meaning: '吃晚餐',
    example: 'We have dinner together.',
    exampleTranslation: '我们一起吃晚餐。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-daily-10',
    phrase: 'take a shower',
    meaning: '洗澡',
    example: 'I take a shower before bed.',
    exampleTranslation: '我睡前洗澡。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-daily-11',
    phrase: 'go to bed',
    meaning: '上床睡觉',
    example: 'I go to bed at 9 pm.',
    exampleTranslation: '我晚上9点上床睡觉。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-daily-12',
    phrase: 'fall asleep',
    meaning: '入睡',
    example: 'I fall asleep quickly.',
    exampleTranslation: '我很快就睡着了。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-daily-13',
    phrase: 'set the table',
    meaning: '摆桌子',
    example: 'Help me set the table.',
    exampleTranslation: '帮我摆桌子。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-daily-14',
    phrase: 'clear the table',
    meaning: '收拾桌子',
    example: 'Please clear the table.',
    exampleTranslation: '请收拾桌子。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-daily-15',
    phrase: 'wash dishes',
    meaning: '洗碗',
    example: 'I help wash dishes.',
    exampleTranslation: '我帮忙洗碗。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-daily-16',
    phrase: 'make the bed',
    meaning: '整理床铺',
    example: 'Make your bed every morning.',
    exampleTranslation: '每天早上整理床铺。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    frequency: 'medium'
  },
  {
    id: 'add-daily-17',
    phrase: 'take out the trash',
    meaning: '倒垃圾',
    example: 'Take out the trash, please.',
    exampleTranslation: '请把垃圾倒掉。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-daily-18',
    phrase: 'water the plants',
    meaning: '浇花',
    example: 'I water the plants every day.',
    exampleTranslation: '我每天浇花。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    frequency: 'medium'
  },
  {
    id: 'add-daily-19',
    phrase: 'feed the pet',
    meaning: '喂宠物',
    example: 'I feed my dog twice a day.',
    exampleTranslation: '我每天喂狗两次。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    frequency: 'medium'
  },
  {
    id: 'add-daily-20',
    phrase: 'walk the dog',
    meaning: '遛狗',
    example: 'I walk the dog after school.',
    exampleTranslation: '放学后我遛狗。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '4',
    frequency: 'medium'
  },

  // 学习相关短语（20个）
  {
    id: 'add-study-1',
    phrase: 'listen to the teacher',
    meaning: '听老师讲课',
    example: 'Listen to the teacher carefully.',
    exampleTranslation: '认真听老师讲课。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-study-2',
    phrase: 'raise hand',
    meaning: '举手',
    example: 'Raise your hand if you know the answer.',
    exampleTranslation: '知道答案的请举手。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-study-3',
    phrase: 'answer the question',
    meaning: '回答问题',
    example: 'Please answer the question.',
    exampleTranslation: '请回答问题。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-study-4',
    phrase: 'ask a question',
    meaning: '提问',
    example: 'You can ask a question.',
    exampleTranslation: '你可以提问。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-study-5',
    phrase: 'take notes',
    meaning: '记笔记',
    example: 'Take notes during the class.',
    exampleTranslation: '上课时记笔记。',
    category: 'school',
    difficulty: 'medium',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-study-6',
    phrase: 'do homework',
    meaning: '做作业',
    example: 'I do my homework after school.',
    exampleTranslation: '放学后我做作业。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-study-7',
    phrase: 'study for a test',
    meaning: '备考',
    example: 'I\'m studying for a test.',
    exampleTranslation: '我正在备考。',
    category: 'school',
    difficulty: 'medium',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-study-8',
    phrase: 'take an exam',
    meaning: '参加考试',
    example: 'We will take an exam tomorrow.',
    exampleTranslation: '我们明天要考试。',
    category: 'school',
    difficulty: 'medium',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-study-9',
    phrase: 'pass the exam',
    meaning: '通过考试',
    example: 'I hope I pass the exam.',
    exampleTranslation: '希望我能通过考试。',
    category: 'school',
    difficulty: 'medium',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-study-10',
    phrase: 'fail the exam',
    meaning: '考试不及格',
    example: 'Don\'t fail the exam!',
    exampleTranslation: '别考试不及格！',
    category: 'school',
    difficulty: 'medium',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-study-11',
    phrase: 'read aloud',
    meaning: '大声朗读',
    example: 'Please read aloud.',
    exampleTranslation: '请大声朗读。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-study-12',
    phrase: 'write down',
    meaning: '写下',
    example: 'Write down your name.',
    exampleTranslation: '写下你的名字。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-study-13',
    phrase: 'look up',
    meaning: '查阅',
    example: 'Look up the word in the dictionary.',
    exampleTranslation: '在字典里查这个词。',
    category: 'school',
    difficulty: 'medium',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-study-14',
    phrase: 'hand in',
    meaning: '上交',
    example: 'Hand in your homework.',
    exampleTranslation: '交作业。',
    category: 'school',
    difficulty: 'medium',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-study-15',
    phrase: 'work in groups',
    meaning: '小组合作',
    example: 'Let\'s work in groups.',
    exampleTranslation: '让我们分组合作。',
    category: 'school',
    difficulty: 'medium',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-study-16',
    phrase: 'share with',
    meaning: '与...分享',
    example: 'Share your ideas with the class.',
    exampleTranslation: '与全班分享你的想法。',
    category: 'school',
    difficulty: 'medium',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-study-17',
    phrase: 'learn by heart',
    meaning: '背诵',
    example: 'Learn this poem by heart.',
    exampleTranslation: '把这首诗背下来。',
    category: 'school',
    difficulty: 'medium',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-study-18',
    phrase: 'practice English',
    meaning: '练习英语',
    example: 'I practice English every day.',
    exampleTranslation: '我每天练习英语。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-study-19',
    phrase: 'make mistakes',
    meaning: '犯错',
    example: 'It\'s okay to make mistakes.',
    exampleTranslation: '犯错没关系。',
    category: 'school',
    difficulty: 'medium',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-study-20',
    phrase: 'correct mistakes',
    meaning: '改正错误',
    example: 'Please correct your mistakes.',
    exampleTranslation: '请改正你的错误。',
    category: 'school',
    difficulty: 'medium',
    grade: '4',
    frequency: 'high'
  },

  // 休闲娱乐短语（20个）
  {
    id: 'add-fun-1',
    phrase: 'play games',
    meaning: '玩游戏',
    example: 'I like to play games with friends.',
    exampleTranslation: '我喜欢和朋友玩游戏。',
    category: 'hobbies',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-fun-2',
    phrase: 'watch TV',
    meaning: '看电视',
    example: 'I watch TV after dinner.',
    exampleTranslation: '晚饭后我看电视。',
    category: 'hobbies',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-fun-3',
    phrase: 'watch a movie',
    meaning: '看电影',
    example: 'Let\'s watch a movie together.',
    exampleTranslation: '我们一起看电影吧。',
    category: 'hobbies',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-fun-4',
    phrase: 'listen to music',
    meaning: '听音乐',
    example: 'I like to listen to music.',
    exampleTranslation: '我喜欢听音乐。',
    category: 'hobbies',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-fun-5',
    phrase: 'play sports',
    meaning: '做运动',
    example: 'I play sports every day.',
    exampleTranslation: '我每天做运动。',
    category: 'hobbies',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-fun-6',
    phrase: 'read books',
    meaning: '读书',
    example: 'I read books before bed.',
    exampleTranslation: '我睡前读书。',
    category: 'hobbies',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-fun-7',
    phrase: 'draw pictures',
    meaning: '画画',
    example: 'I like to draw pictures.',
    exampleTranslation: '我喜欢画画。',
    category: 'hobbies',
    difficulty: 'easy',
    grade: '3',
    frequency: 'medium'
  },
  {
    id: 'add-fun-8',
    phrase: 'take photos',
    meaning: '拍照',
    example: 'I want to take photos.',
    exampleTranslation: '我想拍照。',
    category: 'hobbies',
    difficulty: 'easy',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-fun-9',
    phrase: 'go swimming',
    meaning: '去游泳',
    example: 'Let\'s go swimming!',
    exampleTranslation: '我们去游泳吧！',
    category: 'hobbies',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-fun-10',
    phrase: 'go shopping',
    meaning: '去购物',
    example: 'I go shopping with mom.',
    exampleTranslation: '我和妈妈去购物。',
    category: 'hobbies',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-fun-11',
    phrase: 'go camping',
    meaning: '去露营',
    example: 'We go camping in summer.',
    exampleTranslation: '我们夏天去露营。',
    category: 'hobbies',
    difficulty: 'medium',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-fun-12',
    phrase: 'go hiking',
    meaning: '去徒步',
    example: 'Let\'s go hiking this weekend.',
    exampleTranslation: '这个周末我们去徒步吧。',
    category: 'hobbies',
    difficulty: 'medium',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-fun-13',
    phrase: 'go fishing',
    meaning: '去钓鱼',
    example: 'My dad likes to go fishing.',
    exampleTranslation: '我爸爸喜欢钓鱼。',
    category: 'hobbies',
    difficulty: 'medium',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-fun-14',
    phrase: 'ride a bike',
    meaning: '骑自行车',
    example: 'I can ride a bike.',
    exampleTranslation: '我会骑自行车。',
    category: 'hobbies',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-fun-15',
    phrase: 'fly a kite',
    meaning: '放风筝',
    example: 'Let\'s fly a kite!',
    exampleTranslation: '我们去放风筝吧！',
    category: 'hobbies',
    difficulty: 'easy',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-fun-16',
    phrase: 'play chess',
    meaning: '下棋',
    example: 'My grandpa plays chess.',
    exampleTranslation: '我爷爷下棋。',
    category: 'hobbies',
    difficulty: 'medium',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-fun-17',
    phrase: 'play the piano',
    meaning: '弹钢琴',
    example: 'She can play the piano.',
    exampleTranslation: '她会弹钢琴。',
    category: 'hobbies',
    difficulty: 'medium',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-fun-18',
    phrase: 'play the guitar',
    meaning: '弹吉他',
    example: 'He plays the guitar well.',
    exampleTranslation: '他吉他弹得很好。',
    category: 'hobbies',
    difficulty: 'medium',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-fun-19',
    phrase: 'have a party',
    meaning: '举办派对',
    example: 'We will have a party.',
    exampleTranslation: '我们要举办派对。',
    category: 'hobbies',
    difficulty: 'easy',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-fun-20',
    phrase: 'have fun',
    meaning: '玩得开心',
    example: 'Did you have fun today?',
    exampleTranslation: '你今天玩得开心吗？',
    category: 'hobbies',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },

  // ==================== 小学5-6年级进阶短语（80个）====================

  // 情感表达短语（20个）
  {
    id: 'add-feeling-1',
    phrase: 'be happy about',
    meaning: '为...感到高兴',
    example: 'I\'m happy about the news.',
    exampleTranslation: '我为这个消息感到高兴。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-feeling-2',
    phrase: 'be sad about',
    meaning: '为...感到难过',
    example: 'She is sad about the movie.',
    exampleTranslation: '她为这部电影感到难过。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-feeling-3',
    phrase: 'be angry with',
    meaning: '对...生气',
    example: 'Mom is angry with me.',
    exampleTranslation: '妈妈生我的气了。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-feeling-4',
    phrase: 'be worried about',
    meaning: '担心...',
    example: 'I\'m worried about the test.',
    exampleTranslation: '我担心考试。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-feeling-5',
    phrase: 'be excited about',
    meaning: '对...感到兴奋',
    example: 'I\'m excited about the trip.',
    exampleTranslation: '我对这次旅行感到兴奋。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-feeling-6',
    phrase: 'be surprised at',
    meaning: '对...感到惊讶',
    example: 'I\'m surprised at the result.',
    exampleTranslation: '我对结果感到惊讶。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '6',
    frequency: 'medium'
  },
  {
    id: 'add-feeling-7',
    phrase: 'be afraid of',
    meaning: '害怕...',
    example: 'I\'m afraid of dogs.',
    exampleTranslation: '我怕狗。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-feeling-8',
    phrase: 'be proud of',
    meaning: '为...感到骄傲',
    example: 'I\'m proud of my son.',
    exampleTranslation: '我为我的儿子感到骄傲。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-feeling-9',
    phrase: 'be tired of',
    meaning: '厌倦...',
    example: 'I\'m tired of this game.',
    exampleTranslation: '我厌倦了这个游戏。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '6',
    frequency: 'medium'
  },
  {
    id: 'add-feeling-10',
    phrase: 'be interested in',
    meaning: '对...感兴趣',
    example: 'I\'m interested in science.',
    exampleTranslation: '我对科学感兴趣。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-feeling-11',
    phrase: 'be good at',
    meaning: '擅长...',
    example: 'She is good at singing.',
    exampleTranslation: '她擅长唱歌。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-feeling-12',
    phrase: 'be bad at',
    meaning: '不擅长...',
    example: 'I\'m bad at math.',
    exampleTranslation: '我不擅长数学。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-feeling-13',
    phrase: 'be famous for',
    meaning: '因...而闻名',
    example: 'Paris is famous for the Eiffel Tower.',
    exampleTranslation: '巴黎因埃菲尔铁塔而闻名。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '6',
    frequency: 'medium'
  },
  {
    id: 'add-feeling-14',
    phrase: 'be different from',
    meaning: '与...不同',
    example: 'This book is different from that one.',
    exampleTranslation: '这本书与那本不同。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '6',
    frequency: 'medium'
  },
  {
    id: 'add-feeling-15',
    phrase: 'be similar to',
    meaning: '与...相似',
    example: 'Your answer is similar to mine.',
    exampleTranslation: '你的答案与我的相似。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '6',
    frequency: 'medium'
  },
  {
    id: 'add-feeling-16',
    phrase: 'be late for',
    meaning: '迟到',
    example: 'Don\'t be late for school.',
    exampleTranslation: '上学别迟到。',
    category: 'emotions',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-feeling-17',
    phrase: 'be ready for',
    meaning: '准备好...',
    example: 'Are you ready for the test?',
    exampleTranslation: '你准备好考试了吗？',
    category: 'emotions',
    difficulty: 'medium',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-feeling-18',
    phrase: 'be full of',
    meaning: '充满...',
    example: 'The room is full of people.',
    exampleTranslation: '房间里挤满了人。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '6',
    frequency: 'medium'
  },
  {
    id: 'add-feeling-19',
    phrase: 'be busy with',
    meaning: '忙于...',
    example: 'I\'m busy with homework.',
    exampleTranslation: '我忙着做作业。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-feeling-20',
    phrase: 'be kind to',
    meaning: '对...友好',
    example: 'Be kind to others.',
    exampleTranslation: '对他人友好。',
    category: 'emotions',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },

  // 旅行与交通短语（20个）
  {
    id: 'add-travel-1',
    phrase: 'by bus',
    meaning: '乘公交车',
    example: 'I go to school by bus.',
    exampleTranslation: '我乘公交车去上学。',
    category: 'travel',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-travel-2',
    phrase: 'by car',
    meaning: '乘汽车',
    example: 'We travel by car.',
    exampleTranslation: '我们开车旅行。',
    category: 'travel',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-travel-3',
    phrase: 'by plane',
    meaning: '乘飞机',
    example: 'I go to Beijing by plane.',
    exampleTranslation: '我乘飞机去北京。',
    category: 'travel',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-travel-4',
    phrase: 'by train',
    meaning: '乘火车',
    example: 'We go by train.',
    exampleTranslation: '我们乘火车去。',
    category: 'travel',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-travel-5',
    phrase: 'on foot',
    meaning: '步行',
    example: 'I go to school on foot.',
    exampleTranslation: '我步行去上学。',
    category: 'travel',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-travel-6',
    phrase: 'by bike',
    meaning: '骑自行车',
    example: 'I go by bike.',
    exampleTranslation: '我骑自行车去。',
    category: 'travel',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-travel-7',
    phrase: 'take a taxi',
    meaning: '打车',
    example: 'Let\'s take a taxi.',
    exampleTranslation: '我们打车吧。',
    category: 'travel',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-travel-8',
    phrase: 'get on',
    meaning: '上车',
    example: 'Get on the bus.',
    exampleTranslation: '上公交车。',
    category: 'travel',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-travel-9',
    phrase: 'get off',
    meaning: '下车',
    example: 'Get off at the next station.',
    exampleTranslation: '下一站下车。',
    category: 'travel',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-travel-10',
    phrase: 'arrive at',
    meaning: '到达（小地方）',
    example: 'We arrive at school at 8.',
    exampleTranslation: '我们8点到学校。',
    category: 'travel',
    difficulty: 'medium',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-travel-11',
    phrase: 'arrive in',
    meaning: '到达（大地方）',
    example: 'We arrive in Beijing tomorrow.',
    exampleTranslation: '我们明天到达北京。',
    category: 'travel',
    difficulty: 'medium',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-travel-12',
    phrase: 'go sightseeing',
    meaning: '观光',
    example: 'Let\'s go sightseeing.',
    exampleTranslation: '我们去观光吧。',
    category: 'travel',
    difficulty: 'medium',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-travel-13',
    phrase: 'book a hotel',
    meaning: '预订酒店',
    example: 'I need to book a hotel.',
    exampleTranslation: '我需要预订酒店。',
    category: 'travel',
    difficulty: 'medium',
    grade: '6',
    frequency: 'medium'
  },
  {
    id: 'add-travel-14',
    phrase: 'buy a ticket',
    meaning: '买票',
    example: 'I need to buy a ticket.',
    exampleTranslation: '我需要买票。',
    category: 'travel',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-travel-15',
    phrase: 'check in',
    meaning: '办理登机/入住',
    example: 'Let\'s check in.',
    exampleTranslation: '我们办理登机手续吧。',
    category: 'travel',
    difficulty: 'medium',
    grade: '6',
    frequency: 'medium'
  },
  {
    id: 'add-travel-16',
    phrase: 'check out',
    meaning: '退房',
    example: 'We check out at 12.',
    exampleTranslation: '我们12点退房。',
    category: 'travel',
    difficulty: 'medium',
    grade: '6',
    frequency: 'medium'
  },
  {
    id: 'add-travel-17',
    phrase: 'have a trip',
    meaning: '去旅行',
    example: 'We will have a trip next week.',
    exampleTranslation: '我们下周去旅行。',
    category: 'travel',
    difficulty: 'easy',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-travel-18',
    phrase: 'pack bags',
    meaning: '打包行李',
    example: 'I need to pack my bags.',
    exampleTranslation: '我需要打包行李。',
    category: 'travel',
    difficulty: 'medium',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-travel-19',
    phrase: 'wait for',
    meaning: '等待',
    example: 'Wait for me at the bus stop.',
    exampleTranslation: '在公交车站等我。',
    category: 'travel',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-travel-20',
    phrase: 'on the way',
    meaning: '在路上',
    example: 'I\'m on the way home.',
    exampleTranslation: '我在回家的路上。',
    category: 'travel',
    difficulty: 'medium',
    grade: '5',
    frequency: 'high'
  },

  // 购物相关短语（20个）
  {
    id: 'add-shopping-1',
    phrase: 'how much',
    meaning: '多少钱',
    example: 'How much is this?',
    exampleTranslation: '这个多少钱？',
    category: 'shopping',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-shopping-2',
    phrase: 'on sale',
    meaning: '打折',
    example: 'This shirt is on sale.',
    exampleTranslation: '这件衬衫在打折。',
    category: 'shopping',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-shopping-3',
    phrase: 'try on',
    meaning: '试穿',
    example: 'Can I try it on?',
    exampleTranslation: '我可以试穿吗？',
    category: 'shopping',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-shopping-4',
    phrase: 'fit well',
    meaning: '合身',
    example: 'This dress fits well.',
    exampleTranslation: '这件裙子很合身。',
    category: 'shopping',
    difficulty: 'medium',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-shopping-5',
    phrase: 'pay for',
    meaning: '支付',
    example: 'I\'ll pay for this.',
    exampleTranslation: '我来付钱。',
    category: 'shopping',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-shopping-6',
    phrase: 'pay by credit card',
    meaning: '用信用卡支付',
    example: 'Can I pay by credit card?',
    exampleTranslation: '我可以用信用卡支付吗？',
    category: 'shopping',
    difficulty: 'medium',
    grade: '6',
    frequency: 'medium'
  },
  {
    id: 'add-shopping-7',
    phrase: 'pay in cash',
    meaning: '用现金支付',
    example: 'I\'ll pay in cash.',
    exampleTranslation: '我用现金支付。',
    category: 'shopping',
    difficulty: 'medium',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-shopping-8',
    phrase: 'get a receipt',
    meaning: '拿收据',
    example: 'Can I get a receipt?',
    exampleTranslation: '我可以要收据吗？',
    category: 'shopping',
    difficulty: 'medium',
    grade: '6',
    frequency: 'medium'
  },
  {
    id: 'add-shopping-9',
    phrase: 'keep the change',
    meaning: '不用找零',
    example: 'Keep the change.',
    exampleTranslation: '不用找零了。',
    category: 'shopping',
    difficulty: 'medium',
    grade: '6',
    frequency: 'low'
  },
  {
    id: 'add-shopping-10',
    phrase: 'out of stock',
    meaning: '缺货',
    example: 'This item is out of stock.',
    exampleTranslation: '这个商品缺货。',
    category: 'shopping',
    difficulty: 'medium',
    grade: '6',
    frequency: 'medium'
  },
  {
    id: 'add-shopping-11',
    phrase: 'in stock',
    meaning: '有货',
    example: 'Is this in stock?',
    exampleTranslation: '这个有货吗？',
    category: 'shopping',
    difficulty: 'medium',
    grade: '6',
    frequency: 'medium'
  },
  {
    id: 'add-shopping-12',
    phrase: 'buy some',
    meaning: '买一些',
    example: 'I want to buy some apples.',
    exampleTranslation: '我想买一些苹果。',
    category: 'shopping',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-shopping-13',
    phrase: 'very cheap',
    meaning: '很便宜',
    example: 'This is very cheap!',
    exampleTranslation: '这个很便宜！',
    category: 'shopping',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-shopping-14',
    phrase: 'very expensive',
    meaning: '很贵',
    example: 'This is very expensive.',
    exampleTranslation: '这个很贵。',
    category: 'shopping',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-shopping-15',
    phrase: 'save money',
    meaning: '省钱',
    example: 'I want to save money.',
    exampleTranslation: '我想省钱。',
    category: 'shopping',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-shopping-16',
    phrase: 'spend money',
    meaning: '花钱',
    example: 'Don\'t spend too much money.',
    exampleTranslation: '不要花太多钱。',
    category: 'shopping',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-shopping-17',
    phrase: 'compare prices',
    meaning: '比较价格',
    example: 'Let\'s compare prices.',
    exampleTranslation: '我们比较一下价格吧。',
    category: 'shopping',
    difficulty: 'medium',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-shopping-18',
    phrase: 'make a list',
    meaning: '列清单',
    example: 'Make a shopping list.',
    exampleTranslation: '列一个购物清单。',
    category: 'shopping',
    difficulty: 'easy',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-shopping-19',
    phrase: 'go to the mall',
    meaning: '去商场',
    example: 'Let\'s go to the mall.',
    exampleTranslation: '我们去商场吧。',
    category: 'shopping',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-shopping-20',
    phrase: 'window shopping',
    meaning: '逛商店（只看不买）',
    example: 'Let\'s go window shopping.',
    exampleTranslation: '我们去逛商店吧。',
    category: 'shopping',
    difficulty: 'medium',
    grade: '6',
    frequency: 'low'
  },

  // 健康与运动短语（20个）
  {
    id: 'add-health-1',
    phrase: 'have a cold',
    meaning: '感冒',
    example: 'I have a cold.',
    exampleTranslation: '我感冒了。',
    category: 'health',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-health-2',
    phrase: 'have a fever',
    meaning: '发烧',
    example: 'She has a fever.',
    exampleTranslation: '她发烧了。',
    category: 'health',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-health-3',
    phrase: 'have a headache',
    meaning: '头痛',
    example: 'I have a headache.',
    exampleTranslation: '我头痛。',
    category: 'health',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-health-4',
    phrase: 'have a stomachache',
    meaning: '胃痛',
    example: 'I have a stomachache.',
    exampleTranslation: '我胃痛。',
    category: 'health',
    difficulty: 'medium',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-health-5',
    phrase: 'have a toothache',
    meaning: '牙痛',
    example: 'I have a toothache.',
    exampleTranslation: '我牙痛。',
    category: 'health',
    difficulty: 'medium',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-health-6',
    phrase: 'see a doctor',
    meaning: '看医生',
    example: 'You should see a doctor.',
    exampleTranslation: '你应该去看医生。',
    category: 'health',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-health-7',
    phrase: 'take medicine',
    meaning: '吃药',
    example: 'Take this medicine three times a day.',
    exampleTranslation: '这个药每天吃三次。',
    category: 'health',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-health-8',
    phrase: 'stay in bed',
    meaning: '卧床休息',
    example: 'You need to stay in bed.',
    exampleTranslation: '你需要卧床休息。',
    category: 'health',
    difficulty: 'easy',
    grade: '4',
    frequency: 'medium'
  },
  {
    id: 'add-health-9',
    phrase: 'feel better',
    meaning: '感觉好些了',
    example: 'I hope you feel better soon.',
    exampleTranslation: '希望你快点好起来。',
    category: 'health',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-health-10',
    phrase: 'feel worse',
    meaning: '感觉更糟了',
    example: 'I feel worse today.',
    exampleTranslation: '我今天感觉更糟了。',
    category: 'health',
    difficulty: 'medium',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-health-11',
    phrase: 'stay healthy',
    meaning: '保持健康',
    example: 'Exercise helps you stay healthy.',
    exampleTranslation: '锻炼有助于保持健康。',
    category: 'health',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-health-12',
    phrase: 'eat healthy food',
    meaning: '吃健康食物',
    example: 'We should eat healthy food.',
    exampleTranslation: '我们应该吃健康食物。',
    category: 'health',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-health-13',
    phrase: 'do exercise',
    meaning: '做运动',
    example: 'Do exercise every day.',
    exampleTranslation: '每天做运动。',
    category: 'health',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-health-14',
    phrase: 'keep fit',
    meaning: '保持健康',
    example: 'I want to keep fit.',
    exampleTranslation: '我想保持健康。',
    category: 'health',
    difficulty: 'medium',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-health-15',
    phrase: 'lose weight',
    meaning: '减肥',
    example: 'I want to lose weight.',
    exampleTranslation: '我想减肥。',
    category: 'health',
    difficulty: 'medium',
    grade: '6',
    frequency: 'medium'
  },
  {
    id: 'add-health-16',
    phrase: 'gain weight',
    meaning: '增重',
    example: 'He needs to gain weight.',
    exampleTranslation: '他需要增重。',
    category: 'health',
    difficulty: 'medium',
    grade: '6',
    frequency: 'low'
  },
  {
    id: 'add-health-17',
    phrase: 'drink water',
    meaning: '喝水',
    example: 'Drink more water.',
    exampleTranslation: '多喝水。',
    category: 'health',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-health-18',
    phrase: 'get enough sleep',
    meaning: '睡眠充足',
    example: 'You need to get enough sleep.',
    exampleTranslation: '你需要睡眠充足。',
    category: 'health',
    difficulty: 'medium',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-health-19',
    phrase: 'go to hospital',
    meaning: '去医院',
    example: 'We need to go to hospital.',
    exampleTranslation: '我们需要去医院。',
    category: 'health',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-health-20',
    phrase: 'wear a mask',
    meaning: '戴口罩',
    example: 'Please wear a mask.',
    exampleTranslation: '请戴口罩。',
    category: 'health',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },

  // ==================== 初中7-9年级进阶短语（99个）====================

  // 动词短语（30个）
  {
    id: 'add-mid-verb-1',
    phrase: 'give up',
    meaning: '放弃',
    example: 'Don\'t give up!',
    exampleTranslation: '不要放弃！',
    category: 'verb_phrases',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-verb-2',
    phrase: 'put off',
    meaning: '推迟',
    example: 'Don\'t put off your homework.',
    exampleTranslation: '不要推迟做作业。',
    category: 'verb_phrases',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-verb-3',
    phrase: 'put on',
    meaning: '穿上',
    example: 'Put on your coat.',
    exampleTranslation: '穿上你的外套。',
    category: 'verb_phrases',
    difficulty: 'easy',
    grade: '6',
    frequency: 'high'
  },
  {
    id: 'add-mid-verb-4',
    phrase: 'take off',
    meaning: '脱下',
    example: 'Take off your shoes.',
    exampleTranslation: '脱下你的鞋子。',
    category: 'verb_phrases',
    difficulty: 'easy',
    grade: '6',
    frequency: 'high'
  },
  {
    id: 'add-mid-verb-5',
    phrase: 'turn on',
    meaning: '打开',
    example: 'Turn on the light.',
    exampleTranslation: '打开灯。',
    category: 'verb_phrases',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-verb-6',
    phrase: 'turn off',
    meaning: '关闭',
    example: 'Turn off the TV.',
    exampleTranslation: '关掉电视。',
    category: 'verb_phrases',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-verb-7',
    phrase: 'turn up',
    meaning: '调大',
    example: 'Turn up the volume.',
    exampleTranslation: '把音量调大。',
    category: 'verb_phrases',
    difficulty: 'medium',
    grade: '7',
    frequency: 'medium'
  },
  {
    id: 'add-mid-verb-8',
    phrase: 'turn down',
    meaning: '调小',
    example: 'Turn down the music.',
    exampleTranslation: '把音乐调小声点。',
    category: 'verb_phrases',
    difficulty: 'medium',
    grade: '7',
    frequency: 'medium'
  },
  {
    id: 'add-mid-verb-9',
    phrase: 'work out',
    meaning: '锻炼；解决',
    example: 'I work out every morning.',
    exampleTranslation: '我每天早上锻炼。',
    category: 'verb_phrases',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-verb-10',
    phrase: 'break down',
    meaning: '坏掉',
    example: 'My car broke down.',
    exampleTranslation: '我的车坏了。',
    category: 'verb_phrases',
    difficulty: 'medium',
    grade: '8',
    frequency: 'medium'
  },
  {
    id: 'add-mid-verb-11',
    phrase: 'get over',
    meaning: '克服；恢复',
    example: 'She got over her illness.',
    exampleTranslation: '她恢复了健康。',
    category: 'verb_phrases',
    difficulty: 'medium',
    grade: '8',
    frequency: 'medium'
  },
  {
    id: 'add-mid-verb-12',
    phrase: 'run out of',
    meaning: '用完',
    example: 'We ran out of milk.',
    exampleTranslation: '我们牛奶喝完了。',
    category: 'verb_phrases',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-verb-13',
    phrase: 'look after',
    meaning: '照顾',
    example: 'I look after my little sister.',
    exampleTranslation: '我照顾我的小妹妹。',
    category: 'verb_phrases',
    difficulty: 'easy',
    grade: '6',
    frequency: 'high'
  },
  {
    id: 'add-mid-verb-14',
    phrase: 'look for',
    meaning: '寻找',
    example: 'I\'m looking for my book.',
    exampleTranslation: '我在找我的书。',
    category: 'verb_phrases',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-verb-15',
    phrase: 'look forward to',
    meaning: '期待',
    example: 'I look forward to seeing you.',
    exampleTranslation: '我期待见到你。',
    category: 'verb_phrases',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-verb-16',
    phrase: 'look up to',
    meaning: '尊敬',
    example: 'I look up to my teacher.',
    exampleTranslation: '我尊敬我的老师。',
    category: 'verb_phrases',
    difficulty: 'medium',
    grade: '8',
    frequency: 'medium'
  },
  {
    id: 'add-mid-verb-17',
    phrase: 'look down on',
    meaning: '看不起',
    example: 'Don\'t look down on others.',
    exampleTranslation: '不要看不起别人。',
    category: 'verb_phrases',
    difficulty: 'medium',
    grade: '8',
    frequency: 'medium'
  },
  {
    id: 'add-mid-verb-18',
    phrase: 'get up',
    meaning: '起床',
    example: 'I get up at 7 am.',
    exampleTranslation: '我早上7点起床。',
    category: 'verb_phrases',
    difficulty: 'easy',
    grade: '3',
    frequency: 'high'
  },
  {
    id: 'add-mid-verb-19',
    phrase: 'grow up',
    meaning: '长大',
    example: 'I want to be a teacher when I grow up.',
    exampleTranslation: '我长大后想当老师。',
    category: 'verb_phrases',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-verb-20',
    phrase: 'bring up',
    meaning: '抚养',
    example: 'She was brought up by her grandma.',
    exampleTranslation: '她是由奶奶抚养长大的。',
    category: 'verb_phrases',
    difficulty: 'medium',
    grade: '8',
    frequency: 'medium'
  },
  {
    id: 'add-mid-verb-21',
    phrase: 'set up',
    meaning: '建立',
    example: 'They set up a new company.',
    exampleTranslation: '他们建立了一家新公司。',
    category: 'verb_phrases',
    difficulty: 'medium',
    grade: '8',
    frequency: 'medium'
  },
  {
    id: 'add-mid-verb-22',
    phrase: 'pick up',
    meaning: '捡起；接人',
    example: 'Pick up your toys.',
    exampleTranslation: '捡起你的玩具。',
    category: 'verb_phrases',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-verb-23',
    phrase: 'give back',
    meaning: '归还',
    example: 'Please give back my book.',
    exampleTranslation: '请归还我的书。',
    category: 'verb_phrases',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-verb-24',
    phrase: 'take back',
    meaning: '收回',
    example: 'I take back what I said.',
    exampleTranslation: '我收回我说的话。',
    category: 'verb_phrases',
    difficulty: 'medium',
    grade: '8',
    frequency: 'medium'
  },
  {
    id: 'add-mid-verb-25',
    phrase: 'put away',
    meaning: '收起来',
    example: 'Put away your clothes.',
    exampleTranslation: '把你的衣服收起来。',
    category: 'verb_phrases',
    difficulty: 'easy',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-mid-verb-26',
    phrase: 'throw away',
    meaning: '扔掉',
    example: 'Don\'t throw away the paper.',
    exampleTranslation: '不要把纸扔掉。',
    category: 'verb_phrases',
    difficulty: 'easy',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-mid-verb-27',
    phrase: 'try on',
    meaning: '试穿',
    example: 'Try on this dress.',
    exampleTranslation: '试试这件裙子。',
    category: 'verb_phrases',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-verb-28',
    phrase: 'try out',
    meaning: '试验',
    example: 'Try out this new game.',
    exampleTranslation: '试试这个新游戏。',
    category: 'verb_phrases',
    difficulty: 'medium',
    grade: '7',
    frequency: 'medium'
  },
  {
    id: 'add-mid-verb-29',
    phrase: 'come up with',
    meaning: '想出',
    example: 'She came up with a good idea.',
    exampleTranslation: '她想出了一个好主意。',
    category: 'verb_phrases',
    difficulty: 'medium',
    grade: '8',
    frequency: 'high'
  },
  {
    id: 'add-mid-verb-30',
    phrase: 'catch up with',
    meaning: '赶上',
    example: 'Run faster to catch up with him.',
    exampleTranslation: '跑快点赶上他。',
    category: 'verb_phrases',
    difficulty: 'medium',
    grade: '8',
    frequency: 'high'
  },

  // 连词和结构短语（30个）
  {
    id: 'add-mid-struct-1',
    phrase: 'not only...but also',
    meaning: '不仅...而且',
    example: 'She is not only smart but also kind.',
    exampleTranslation: '她不仅聪明而且善良。',
    category: 'structures',
    difficulty: 'hard',
    grade: '8',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-2',
    phrase: 'either...or',
    meaning: '要么...要么',
    example: 'You can either stay or go.',
    exampleTranslation: '你可以留下或者离开。',
    category: 'structures',
    difficulty: 'medium',
    grade: '7',
    frequency: 'medium'
  },
  {
    id: 'add-mid-struct-3',
    phrase: 'neither...nor',
    meaning: '既不...也不',
    example: 'Neither Tom nor I like swimming.',
    exampleTranslation: '汤姆和我都不喜欢游泳。',
    category: 'structures',
    difficulty: 'medium',
    grade: '8',
    frequency: 'medium'
  },
  {
    id: 'add-mid-struct-4',
    phrase: 'both...and',
    meaning: '两者都',
    example: 'Both Tom and I like music.',
    exampleTranslation: '汤姆和我都喜欢音乐。',
    category: 'structures',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-5',
    phrase: 'so...that',
    meaning: '如此...以至于',
    example: 'He is so tired that he can\'t walk.',
    exampleTranslation: '他太累了以至于走不动路。',
    category: 'structures',
    difficulty: 'hard',
    grade: '8',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-6',
    phrase: 'such...that',
    meaning: '如此...以至于',
    example: 'It is such a nice day that we go out.',
    exampleTranslation: '天气这么好，我们出去了。',
    category: 'structures',
    difficulty: 'hard',
    grade: '8',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-7',
    phrase: 'too...to',
    meaning: '太...以至于不能',
    example: 'He is too young to drive.',
    exampleTranslation: '他太年轻了不能开车。',
    category: 'structures',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-8',
    phrase: 'enough...to',
    meaning: '足够...可以',
    example: 'He is old enough to go to school.',
    exampleTranslation: '他年龄够大可以上学了。',
    category: 'structures',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-9',
    phrase: 'as soon as',
    meaning: '一...就',
    example: 'I\'ll call you as soon as I arrive.',
    exampleTranslation: '我一到就给你打电话。',
    category: 'structures',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-10',
    phrase: 'as long as',
    meaning: '只要',
    example: 'You can play as long as you finish homework.',
    exampleTranslation: '只要你完成作业就可以玩。',
    category: 'structures',
    difficulty: 'medium',
    grade: '8',
    frequency: 'medium'
  },
  {
    id: 'add-mid-struct-11',
    phrase: 'even though',
    meaning: '即使',
    example: 'I\'ll go even though it rains.',
    exampleTranslation: '即使下雨我也要去。',
    category: 'structures',
    difficulty: 'medium',
    grade: '8',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-12',
    phrase: 'even if',
    meaning: '即使',
    example: 'I\'ll help you even if I\'m busy.',
    exampleTranslation: '即使我很忙也会帮你。',
    category: 'structures',
    difficulty: 'medium',
    grade: '8',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-13',
    phrase: 'no matter',
    meaning: '无论',
    example: 'No matter what happens, I\'ll be there.',
    exampleTranslation: '无论发生什么，我都会在那里。',
    category: 'structures',
    difficulty: 'medium',
    grade: '8',
    frequency: 'medium'
  },
  {
    id: 'add-mid-struct-14',
    phrase: 'as if',
    meaning: '好像',
    example: 'He talks as if he knows everything.',
    exampleTranslation: '他说得好像他什么都知道。',
    category: 'structures',
    difficulty: 'hard',
    grade: '9',
    frequency: 'medium'
  },
  {
    id: 'add-mid-struct-15',
    phrase: 'as well as',
    meaning: '也，还',
    example: 'She can sing as well as dance.',
    exampleTranslation: '她既会唱歌也会跳舞。',
    category: 'structures',
    difficulty: 'medium',
    grade: '8',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-16',
    phrase: 'instead of',
    meaning: '而不是',
    example: 'I\'ll have tea instead of coffee.',
    exampleTranslation: '我要茶而不是咖啡。',
    category: 'structures',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-17',
    phrase: 'because of',
    meaning: '因为',
    example: 'We stayed home because of the rain.',
    exampleTranslation: '因为下雨我们待在家里。',
    category: 'structures',
    difficulty: 'easy',
    grade: '6',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-18',
    phrase: 'in order to',
    meaning: '为了',
    example: 'I study hard in order to pass the exam.',
    exampleTranslation: '为了通过考试我努力学习。',
    category: 'structures',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-19',
    phrase: 'so that',
    meaning: '以便',
    example: 'I get up early so that I can catch the bus.',
    exampleTranslation: '我早起以便能赶上公交车。',
    category: 'structures',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-20',
    phrase: 'in case',
    meaning: '以防',
    example: 'Take an umbrella in case it rains.',
    exampleTranslation: '带把伞以防下雨。',
    category: 'structures',
    difficulty: 'medium',
    grade: '8',
    frequency: 'medium'
  },
  {
    id: 'add-mid-struct-21',
    phrase: 'by the time',
    meaning: '到...时候',
    example: 'By the time I got there, he had left.',
    exampleTranslation: '我到那儿的时候他已经离开了。',
    category: 'structures',
    difficulty: 'hard',
    grade: '9',
    frequency: 'medium'
  },
  {
    id: 'add-mid-struct-22',
    phrase: 'the more...the more',
    meaning: '越...越',
    example: 'The more you practice, the better you get.',
    exampleTranslation: '你练习得越多，就会越好。',
    category: 'structures',
    difficulty: 'hard',
    grade: '9',
    frequency: 'medium'
  },
  {
    id: 'add-mid-struct-23',
    phrase: 'it takes...to',
    meaning: '花费...做某事',
    example: 'It takes me 30 minutes to walk to school.',
    exampleTranslation: '我步行上学需要30分钟。',
    category: 'structures',
    difficulty: 'medium',
    grade: '6',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-24',
    phrase: 'would rather...than',
    meaning: '宁愿...也不',
    example: 'I would rather stay home than go out.',
    exampleTranslation: '我宁愿待在家里也不愿出去。',
    category: 'structures',
    difficulty: 'hard',
    grade: '9',
    frequency: 'medium'
  },
  {
    id: 'add-mid-struct-25',
    phrase: 'prefer...to',
    meaning: '比起...更喜欢',
    example: 'I prefer tea to coffee.',
    exampleTranslation: '比起咖啡我更喜欢茶。',
    category: 'structures',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-26',
    phrase: 'used to',
    meaning: '过去常常',
    example: 'I used to play basketball.',
    exampleTranslation: '我过去常常打篮球。',
    category: 'structures',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-27',
    phrase: 'be used to',
    meaning: '习惯于',
    example: 'I\'m used to getting up early.',
    exampleTranslation: '我习惯早起了。',
    category: 'structures',
    difficulty: 'medium',
    grade: '8',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-28',
    phrase: 'had better',
    meaning: '最好',
    example: 'You had better study hard.',
    exampleTranslation: '你最好努力学习。',
    category: 'structures',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-29',
    phrase: 'would like to',
    meaning: '想要',
    example: 'I would like to have some tea.',
    exampleTranslation: '我想要一些茶。',
    category: 'structures',
    difficulty: 'easy',
    grade: '6',
    frequency: 'high'
  },
  {
    id: 'add-mid-struct-30',
    phrase: 'be able to',
    meaning: '能够',
    example: 'I will be able to speak English well.',
    exampleTranslation: '我将能够说好英语。',
    category: 'structures',
    difficulty: 'easy',
    grade: '6',
    frequency: 'high'
  },

  // 常用表达（39个）
  {
    id: 'add-mid-expr-1',
    phrase: 'all of a sudden',
    meaning: '突然',
    example: 'All of a sudden, it started to rain.',
    exampleTranslation: '突然开始下雨了。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-2',
    phrase: 'to one\'s surprise',
    meaning: '令某人惊讶的是',
    example: 'To my surprise, he passed the exam.',
    exampleTranslation: '令我惊讶的是，他通过了考试。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-3',
    phrase: 'in other words',
    meaning: '换句话说',
    example: 'In other words, you don\'t want to go.',
    exampleTranslation: '换句话说，你不想去。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-4',
    phrase: 'on the other hand',
    meaning: '另一方面',
    example: 'On the other hand, it\'s expensive.',
    exampleTranslation: '另一方面，它很贵。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-5',
    phrase: 'by oneself',
    meaning: '独自地',
    example: 'I can do it by myself.',
    exampleTranslation: '我可以自己做。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-6',
    phrase: 'for oneself',
    meaning: '为自己',
    example: 'You should decide for yourself.',
    exampleTranslation: '你应该自己决定。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-7',
    phrase: 'of course not',
    meaning: '当然不',
    example: 'Of course not! I would never do that.',
    exampleTranslation: '当然不！我绝不会那样做。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-8',
    phrase: 'not at all',
    meaning: '一点也不',
    example: 'Not at all, I\'m happy to help.',
    exampleTranslation: '一点也不，我很乐意帮忙。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-9',
    phrase: 'so far',
    meaning: '到目前为止',
    example: 'So far, everything is good.',
    exampleTranslation: '到目前为止，一切都好。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-10',
    phrase: 'up to',
    meaning: '直到；多达',
    example: 'Up to now, I haven\'t heard from him.',
    exampleTranslation: '直到现在，我还没收到他的消息。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-11',
    phrase: 'day by day',
    meaning: '一天天',
    example: 'He is getting better day by day.',
    exampleTranslation: '他一天天好起来了。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-12',
    phrase: 'step by step',
    meaning: '一步步地',
    example: 'Learn English step by step.',
    exampleTranslation: '一步步学英语。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '6',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-13',
    phrase: 'one by one',
    meaning: '一个接一个',
    example: 'They came in one by one.',
    exampleTranslation: '他们一个接一个地进来。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-14',
    phrase: 'at first',
    meaning: '起初',
    example: 'At first, I didn\'t like it.',
    exampleTranslation: '起初，我不喜欢它。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-15',
    phrase: 'at last',
    meaning: '最后',
    example: 'At last, we arrived.',
    exampleTranslation: '最后，我们到了。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-16',
    phrase: 'in the end',
    meaning: '最后',
    example: 'In the end, we won the game.',
    exampleTranslation: '最后，我们赢了比赛。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-17',
    phrase: 'at present',
    meaning: '目前',
    example: 'At present, I\'m studying English.',
    exampleTranslation: '目前，我正在学英语。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-18',
    phrase: 'in the past',
    meaning: '在过去',
    example: 'In the past, people lived differently.',
    exampleTranslation: '在过去，人们的生活方式不同。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-19',
    phrase: 'in the future',
    meaning: '在未来',
    example: 'In the future, cars will fly.',
    exampleTranslation: '在未来，汽车会飞。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-20',
    phrase: 'from now on',
    meaning: '从现在开始',
    example: 'From now on, I will study hard.',
    exampleTranslation: '从现在开始，我会努力学习。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-21',
    phrase: 'right now',
    meaning: '现在',
    example: 'I\'m busy right now.',
    exampleTranslation: '我现在很忙。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-22',
    phrase: 'right away',
    meaning: '立刻',
    example: 'I\'ll do it right away.',
    exampleTranslation: '我立刻就做。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-23',
    phrase: 'at once',
    meaning: '立刻',
    example: 'Come here at once!',
    exampleTranslation: '立刻过来！',
    category: 'expressions',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-24',
    phrase: 'just now',
    meaning: '刚才',
    example: 'I saw him just now.',
    exampleTranslation: '我刚才看到他了。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-25',
    phrase: 'sooner or later',
    meaning: '迟早',
    example: 'Sooner or later, you will understand.',
    exampleTranslation: '迟早你会明白的。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-26',
    phrase: 'once upon a time',
    meaning: '很久以前',
    example: 'Once upon a time, there was a king.',
    exampleTranslation: '很久以前，有一个国王。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '5',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-27',
    phrase: 'from time to time',
    meaning: '有时',
    example: 'I visit my grandma from time to time.',
    exampleTranslation: '我有时去看望奶奶。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-28',
    phrase: 'all the time',
    meaning: '一直',
    example: 'She talks all the time.',
    exampleTranslation: '她一直在说话。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-29',
    phrase: 'on time',
    meaning: '准时',
    example: 'Please be on time.',
    exampleTranslation: '请准时。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '4',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-30',
    phrase: 'in time',
    meaning: '及时',
    example: 'We arrived in time for the movie.',
    exampleTranslation: '我们及时赶上了电影。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-31',
    phrase: 'for the time being',
    meaning: '暂时',
    example: 'For the time being, I\'ll stay here.',
    exampleTranslation: '暂时我会待在这里。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-32',
    phrase: 'at the same time',
    meaning: '同时',
    example: 'They arrived at the same time.',
    exampleTranslation: '他们同时到达。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '5',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-33',
    phrase: 'in fact',
    meaning: '事实上',
    example: 'In fact, I don\'t like it.',
    exampleTranslation: '事实上，我不喜欢它。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-34',
    phrase: 'as a matter of fact',
    meaning: '事实上',
    example: 'As a matter of fact, I agree with you.',
    exampleTranslation: '事实上，我同意你的看法。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-35',
    phrase: 'to be honest',
    meaning: '老实说',
    example: 'To be honest, I don\'t know.',
    exampleTranslation: '老实说，我不知道。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    frequency: 'high'
  },
  {
    id: 'add-mid-expr-36',
    phrase: 'to tell the truth',
    meaning: '说实话',
    example: 'To tell the truth, I\'m tired.',
    exampleTranslation: '说实话，我累了。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-37',
    phrase: 'in general',
    meaning: '总的来说',
    example: 'In general, I like it.',
    exampleTranslation: '总的来说，我喜欢它。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-38',
    phrase: 'generally speaking',
    meaning: '一般来说',
    example: 'Generally speaking, it\'s a good idea.',
    exampleTranslation: '一般来说，这是个好主意。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    frequency: 'medium'
  },
  {
    id: 'add-mid-expr-39',
    phrase: 'after all',
    meaning: '毕竟',
    example: 'After all, he is only a child.',
    exampleTranslation: '毕竟，他只是个孩子。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    frequency: 'medium'
  }
];
